function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { getAuth as $ebtLO$getAuth, signInWithCustomToken as $ebtLO$signInWithCustomToken } from "firebase/auth";
import { jwtDecode as $ebtLO$jwtDecode } from "jwt-decode";
import { initializeApp as $ebtLO$initializeApp } from "firebase/app";
function $7c58d1d9dd6a0a7b$export$34e01efe67aefa45(token) {
  return (0, $ebtLO$jwtDecode)(token);
}
var $2d8fcde8bb309f46$export$7587955500404ec3 = /*#__PURE__*/function () {
  function $2d8fcde8bb309f46$export$7587955500404ec3(url, init) {
    _classCallCheck(this, $2d8fcde8bb309f46$export$7587955500404ec3);
    this._url = url;
    this._headers = init.headers;
  }
  _createClass($2d8fcde8bb309f46$export$7587955500404ec3, [{
    key: "headers",
    get: function get() {
      return this._headers;
    }
  }, {
    key: "url",
    get: function get() {
      return this._url;
    }
  }, {
    key: "toBrowserRequest",
    value: function toBrowserRequest() {
      var headers = new Headers();
      Object.entries(this.headers).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          values = _ref2[1];
        values.forEach(function (value) {
          headers.append(key, value);
        });
      });
      return new Request(this.url, {
        headers: headers
      });
    }
  }]);
  return $2d8fcde8bb309f46$export$7587955500404ec3;
}();
var $622c966ccbe9a85c$export$2e2bcd8739ae039 = {
  initializeApp: (0, $ebtLO$initializeApp)
};
var $ff4f086a8cb98625$export$307618192c5b896c = /*#__PURE__*/function () {
  function $ff4f086a8cb98625$export$307618192c5b896c() {
    _classCallCheck(this, $ff4f086a8cb98625$export$307618192c5b896c);
    this.cache = new Map();
  }
  _createClass($ff4f086a8cb98625$export$307618192c5b896c, [{
    key: "get",
    value: function get(credentials) {
      var cacheKey = credentials.authDomain;
      var cached = this.cacheGet(cacheKey);
      if (cached) return cached;
      var app = $622c966ccbe9a85c$export$2e2bcd8739ae039.initializeApp(credentials, cacheKey);
      this.cacheSet(cacheKey, app);
      return app;
    }
  }, {
    key: "cacheGet",
    value: function cacheGet(key) {
      return this.cache.get(key);
    }
  }, {
    key: "cacheSet",
    value: function cacheSet(key, value) {
      this.cache.set(key, value);
    }
  }]);
  return $ff4f086a8cb98625$export$307618192c5b896c;
}();
var $20fafc7421db3515$export$ec1a18cf15f9d70d = /*#__PURE__*/function () {
  function $20fafc7421db3515$export$ec1a18cf15f9d70d(options) {
    _classCallCheck(this, $20fafc7421db3515$export$ec1a18cf15f9d70d);
    this.createBrowserSessionFunction = options.createBrowserSessionFunction;
    this.firebaseAppManager = options.firebaseAppManager || new (0, $ff4f086a8cb98625$export$307618192c5b896c)();
  }
  /**
  * Create a Request for use with the Fetch API. The Request is encoded with
  * both the URL and Headers necessary to execute the UCS API call using
  * the Fetch API `fetch` function.
  *
  * It is not advised to create your own Request, as the one returned by this
  * method is guaranteed to work with the deployed UCS infrastructure. If you
  * build your own request, it may not be configured correctly.
  *
  * @note This only builds requests for the UCS Browser API Proxy.
  *
  * @example Build and execute a request to get a UCS File by ID
  *
  *     // Using an existing UcdSdk instance created by `initializeSdk`
  *     const fileId = "291de534-d1f6-4d39-8e65-f0d66b9f0450"
  *
  *     // Build the request. The method is async because it may need
  *     // to issue network calls to generate an ID Token to authorize
  *     // the request.
  *     const request = await sdk.buildRequest(`/v1/files/${fileId}`)
  *
  *     // Use the Fetch API `fetch` function as you normally would
  *     const response = await fetch(request.toBrowserRequest())
  * */
  _createClass($20fafc7421db3515$export$ec1a18cf15f9d70d, [{
    key: "buildRequest",
    value: function () {
      var _buildRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(path) {
        var _yield$this$getParsed, proxyUrl, idToken;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getParsedBrowserSessionToken();
            case 2:
              _yield$this$getParsed = _context.sent;
              proxyUrl = _yield$this$getParsed.claims.proxyUrl;
              _context.next = 6;
              return this.getIdentityToken();
            case 6:
              idToken = _context.sent;
              return _context.abrupt("return", new (0, $2d8fcde8bb309f46$export$7587955500404ec3)(new URL(path, proxyUrl).toString(), {
                headers: {
                  Authorization: ["Bearer ".concat(idToken)]
                }
              }));
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function buildRequest(_x) {
        return _buildRequest.apply(this, arguments);
      }
      return buildRequest;
    }()
    /**
    * Create an Identity Token to authenticate requests to UCS services that
    * accept browser authentication.
    *
    * It is recommended that you use the `buildRequest` method instead, but this
    * is here if you know what you are doing.
    *
    * @see buildRequest
    * */
  }, {
    key: "getIdentityToken",
    value: function () {
      var _getIdentityToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var user;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.getUser();
            case 2:
              user = _context2.sent;
              return _context2.abrupt("return", user.getIdToken());
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getIdentityToken() {
        return _getIdentityToken.apply(this, arguments);
      }
      return getIdentityToken;
    }()
    /**
    * Get the UCS Tus URL from Browser Session Token. You should not be
    * extracting data from the Browser Session Token manually, which is why
    * these helper methods are here.
    * */
  }, {
    key: "getTusUrl",
    value: function () {
      var _getTusUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _yield$this$getParsed2, tusUrl;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.getParsedBrowserSessionToken();
            case 2:
              _yield$this$getParsed2 = _context3.sent;
              tusUrl = _yield$this$getParsed2.claims.tusUrl;
              return _context3.abrupt("return", tusUrl);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getTusUrl() {
        return _getTusUrl.apply(this, arguments);
      }
      return getTusUrl;
    }()
    /**
    * Invokes the client provided function to create the UCS Browser Session
    * from their own backend.
    *
    * @todo This is permanently cached. If an underlying Firebase auth error
    *    happens (cannot use refresh token, etc.) we would want to invoke
    *    this again. Will revisit that later.
    *
    * @see {initializeSdk}
    * */
  }, {
    key: "getBrowserSession",
    value: function () {
      var _getBrowserSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!this.browserSession) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return", this.browserSession);
            case 2:
              _context4.next = 4;
              return this.createBrowserSessionFunction();
            case 4:
              this.browserSession = _context4.sent;
              return _context4.abrupt("return", this.browserSession);
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getBrowserSession() {
        return _getBrowserSession.apply(this, arguments);
      }
      return getBrowserSession;
    }()
    /**
    * Uses the UCS Browser Session token to authenticate the end-user with
    * GCP Identity Platform. This request does not invoke any UCS resources.
    *
    * @return A Firebase User object, which can be used to generate ID Tokens
    * to authenticate requests to the UCS Browser Auth Proxy.
    * */
  }, {
    key: "getUser",
    value: function () {
      var _getUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!this.getUserPromise) this.getUserPromise = this.createAndAuthenticateUser();
              return _context5.abrupt("return", this.getUserPromise);
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getUser() {
        return _getUser.apply(this, arguments);
      }
      return getUser;
    }()
    /**
    * Uses createBrowserSessionFunction provided in SDK creation to fetch
    * BrowserSession from your application's backend, and uses it to
    * authenticate with Google Identity Platform (Firebase)
    * */
  }, {
    key: "createAndAuthenticateUser",
    value: function () {
      var _createAndAuthenticateUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var browserSession, app, auth, credential;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!this.user) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return", this.user);
            case 2:
              _context6.next = 4;
              return this.getBrowserSession();
            case 4:
              browserSession = _context6.sent;
              // Initialize Firebase SDK, which is used to interact with Identity Platform
              app = this.firebaseAppManager.get(browserSession.firebaseCredentials);
              auth = (0, $ebtLO$getAuth)(app); // Authenticate the end-user with Identity Platform using the UCS Browser Session token
              _context6.next = 9;
              return (0, $ebtLO$signInWithCustomToken)(auth, browserSession.token);
            case 9:
              credential = _context6.sent;
              this.user = credential.user;
              return _context6.abrupt("return", this.user);
            case 12:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function createAndAuthenticateUser() {
        return _createAndAuthenticateUser.apply(this, arguments);
      }
      return createAndAuthenticateUser;
    }()
    /**
    * Extracts the UCS Browser Auth Proxy configuration details from the
    * Browser Session token created by the UCS API Create Browser Session
    * resource. This configuration is encoded in the JWT token as custom
    * claims.
    * */
  }, {
    key: "getParsedBrowserSessionToken",
    value: function () {
      var _getParsedBrowserSessionToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var browserSession;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.getBrowserSession();
            case 2:
              browserSession = _context7.sent;
              return _context7.abrupt("return", (0, $7c58d1d9dd6a0a7b$export$34e01efe67aefa45)(browserSession.token));
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function getParsedBrowserSessionToken() {
        return _getParsedBrowserSessionToken.apply(this, arguments);
      }
      return getParsedBrowserSessionToken;
    }()
  }]);
  return $20fafc7421db3515$export$ec1a18cf15f9d70d;
}();
function $8fc577426f6a3f74$export$323bcea6fefcd733(options) {
  return new (0, $20fafc7421db3515$export$ec1a18cf15f9d70d)(options);
}
export { $8fc577426f6a3f74$export$323bcea6fefcd733 as initializeSdk };